import { Component, Input, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DynamicAttributesDialogComponent } from './dynamic-attributes-dialog/dynamic-attributes-dialog.component';
import { DynamicSubjectService } from './dynamic-attribute-subject-behavior';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'app-dynamic-attributes',
  templateUrl: './dynamic-attributes.component.html',
  styleUrls: ['./dynamic-attributes.component.scss'],
})
export class DynamicAttributesComponent implements OnInit, OnDestroy {
  @Input() attributes: Array<any> = [];
  @Input() attribute: any;
  @Input() title = '';
  @Input() currentFormId = '';
  @Input() attribute_type = '';
  @Input() userId = '';
  @Input() isRemoveEditSaveSharing = false;
  filterList = [];
  subscription = new Subscription();

  constructor(private dialog: MatDialog, private dynamicSubjectService: DynamicSubjectService) {}

  ngOnInit(): void {
    // console.log({ attribute: this.attribute, attributes: this.attributes });
    if (!!this.attribute?.getFormValues) {
      const valueData = JSON.parse(this.attribute?.getFormValues?.attribute?.value);
      this.filterList = this.attributes.filter((attr) => valueData[attr.key] !== undefined && valueData[attr.key] !== null);
      // console.log({ valueData, filterList: this.filterList });
    } else {
      // console.log({ attribute: this.attribute });
      const seen = new Set();
      this.filterList = this.attributes.filter((item) => {
        if (seen.has(item.title.toLowerCase())) {
          return false;
        }
        seen.add(item.title.toLowerCase());
        return true;
      });
      // console.log({ attribute: this.attribute });
    }
  }

  openFormDialog() {
    const dialogRef = this.dialog.open(DynamicAttributesDialogComponent, {
      width: '550',
      height: 'auto',
      minHeight: '280px',
      panelClass: 'attributes-dialog',
      data: {
        mode: 'create',
        title: this?.title,
        userId: this.userId,
        attributes: this.attributes,
        attribute: this.attribute,
        //   userId: this.userId,
        currentFormId: this.currentFormId,
        triggeredFrom: this.title,
        attribute_type: this.attribute_type,
        attributeType: 'financial-attribute',
        expenseCategories: [],
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((data) => {
        if (data) {
          this.dynamicSubjectService.handleGetValues(data);
        }
      })
    );
  }
  handleStyleClassForAttributeValues(input: any) {
    if (typeof input?.type === 'string') {
      if (input?.type?.toLowerCase().includes('dollar') || input?.type?.toLowerCase().includes('amount')) {
        return 'font-bold text-lg text-k-black';
      } else {
        return 'font-semibold text-base text-k-black';
      }
    }
    return 'font-semibold text-base text-k-black';
  }
  getAttributeItemValue(input: { title: string; key: string; type: string; default?: string }) {
    return '-';
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
